var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundFees({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10770",
    "data-name": "Group 10770",
    transform: "translate(-294.824 -1194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10745",
    "data-name": "Group 10745",
    transform: "translate(79.824 75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pay_-_Free_business_and_finance_icons-2",
    "data-name": "Pay - Free business and finance icons-2",
    transform: "translate(236 1144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money_\\xB7_paid_\\xB7_shopping_\\xB7_payment_\\xB7_ecommerce",
    "data-name": "money \\xB7 paid \\xB7 shopping \\xB7 payment \\xB7 ecommerce"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10386",
    "data-name": "Path 10386",
    d: "M37,25H31V23a3.009,3.009,0,0,0-3-3,2.942,2.942,0,0,0-1.47.4A2.983,2.983,0,0,0,24,19a3.02,3.02,0,0,0-1.12.22,2.978,2.978,0,0,0-5.76,0A2.994,2.994,0,0,0,13,22v3H3a1,1,0,0,0-1,1V44a1,1,0,0,0,1,1H9v1.17a2.956,2.956,0,0,0,.88,2.12l.83.83a.99.99,0,0,1,.29.71V52H10a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1H30a1,1,0,0,0,1-1V53a1,1,0,0,0-1-1H29V49.83a.99.99,0,0,1,.29-.71l.83-.83A2.956,2.956,0,0,0,31,46.17V45h6a1,1,0,0,0,1-1V26A1,1,0,0,0,37,25ZM27,23a1,1,0,0,1,2,0v2H27Zm-4-1a1,1,0,0,1,2,0v3H23Zm-4-2a1,1,0,0,1,2,0v5H19Zm-4,2a1,1,0,0,1,2,0v3H15ZM4,27H7.9A5.01,5.01,0,0,1,4,30.9ZM4,43V39.1A5.01,5.01,0,0,1,7.9,43ZM29,60H11V54H29Zm0-13.83a.99.99,0,0,1-.29.71l-.83.83A2.956,2.956,0,0,0,27,49.83V52H13V49.83a2.956,2.956,0,0,0-.88-2.12l-.83-.83a.99.99,0,0,1-.29-.71V37a1,1,0,0,1,2,0v2a1.033,1.033,0,0,0,.29.71l1.42,1.41a.99.99,0,0,1,.29.71V44a1,1,0,0,0,1,1H29ZM36,43H32.1A5.01,5.01,0,0,1,36,39.1Zm0-5.92A7,7,0,0,0,30.08,43H17V41.83a2.956,2.956,0,0,0-.88-2.12L15,38.59V37a3,3,0,0,0-6,0v3.41a7.04,7.04,0,0,0-5-3.33V32.92A7,7,0,0,0,9.92,27H30.08A7,7,0,0,0,36,32.92Zm0-6.18A5.01,5.01,0,0,1,32.1,27H36Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    "data-name": "Path 10388",
    d: "M20,13a1,1,0,0,0,1-1V10a1,1,0,0,0-2,0v2A1,1,0,0,0,20,13Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10389",
    "data-name": "Path 10389",
    d: "M14.634,13.706a1,1,0,1,0,1.732-1l-1-1.732a1,1,0,1,0-1.732,1Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10390",
    "data-name": "Path 10390",
    d: "M9.974,16.366l1.732,1a1,1,0,1,0,1-1.732l-1.732-1a1,1,0,1,0-1,1.732Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10391",
    "data-name": "Path 10391",
    d: "M24,14.072a1,1,0,0,0,1.366-.366l1-1.732a1,1,0,1,0-1.732-1l-1,1.732A1,1,0,0,0,24,14.072Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10392",
    "data-name": "Path 10392",
    d: "M27.8,17.5a.992.992,0,0,0,.5-.134l1.732-1a1,1,0,1,0-1-1.732l-1.732,1a1,1,0,0,0,.5,1.866Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10393",
    "data-name": "Path 10393",
    d: "M26,56H25a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10394",
    "data-name": "Path 10394",
    d: "M61,12a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H41a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1h1v2.17a.99.99,0,0,1-.29.71l-.83.83A2.956,2.956,0,0,0,40,17.83V29a3.009,3.009,0,0,0,3,3h1v6a2.994,2.994,0,0,0,4.12,2.78,2.978,2.978,0,0,0,5.76,0A3.02,3.02,0,0,0,55,41a2.983,2.983,0,0,0,2.53-1.4A2.942,2.942,0,0,0,59,40a3.009,3.009,0,0,0,3-3V17.83a2.956,2.956,0,0,0-.88-2.12l-.83-.83a.99.99,0,0,1-.29-.71V12ZM60,37a1,1,0,0,1-2,0V30a1,1,0,0,0-2,0v8a1,1,0,0,1-2,0V30a1,1,0,0,0-2,0V40a1,1,0,0,1-2,0V30a1,1,0,0,0-2,0v8a1,1,0,0,1-2,0V25.9A5.009,5.009,0,0,0,50,21V20a1,1,0,0,0-2,0v1a3.009,3.009,0,0,1-3,3,1,1,0,0,0-1,1v5H43a1,1,0,0,1-1-1V17.83a.99.99,0,0,1,.29-.71l.83-.83A2.956,2.956,0,0,0,44,14.17V12H58v2.17a2.956,2.956,0,0,0,.88,2.12l.83.83a.99.99,0,0,1,.29.71ZM42,10V4H60v6Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10395",
    "data-name": "Path 10395",
    d: "M56,8h1a1,1,0,0,0,0-2H56a1,1,0,0,0,0,2Z",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    transform: "translate(16 30)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 4.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10744",
    "data-name": "Group 10744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10396",
    "data-name": "Path 10396",
    d: "M133.567,247.467a1.683,1.683,0,0,0-1.683,1.683,47.113,47.113,0,0,1-83.207,30.3h9.14a1.683,1.683,0,1,0,0-3.367H44.35a1.683,1.683,0,0,0-1.683,1.683v13.467a1.683,1.683,0,0,0,3.367,0v-9.695A50.48,50.48,0,0,0,135.25,249.15,1.683,1.683,0,0,0,133.567,247.467Z",
    transform: "translate(180.75 920.35)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10397",
    "data-name": "Path 10397",
    d: "M50.5,3.367A47.3,47.3,0,0,1,86.573,20.2h-9.14a1.683,1.683,0,0,0,0,3.367H90.9a1.683,1.683,0,0,0,1.683-1.683V8.417a1.683,1.683,0,0,0-3.367,0v9.695A50.48,50.48,0,0,0,0,50.5a1.683,1.683,0,0,0,3.367,0A47.186,47.186,0,0,1,50.5,3.367Z",
    transform: "translate(215 1119)",
    fill: "#00641f"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundFees);
export default __webpack_public_path__ + "static/media/refundFees.75aa466806352ad26d96d2f5df5d40ec.svg";
export { ForwardRef as ReactComponent };